<template>
    <v-container style="height: 100vh" class="d-flex align-center">
        <v-row class="d-flex align-center justify-center fill-height" style="height: 100%">
            <v-col cols="10" md="4">
                <div>
                    <div class="d-flex justify-center mb-4">
                        <img
                            :src="Bobbee"
                            :height="!$vuetify.display.mobile ? '100vh' : ''"
                            :width="!$vuetify.display.mobile ? '' : '200vw'"
                        />
                    </div>
                    <v-col cols="12" class="d-flex justify-center display-2">
                        Erreur 404: Page non trouvée
                    </v-col>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";

import BobbeeLogoImport from "@/assets/img/bobbee_logo_3_CMJN_by_agiris.png";

@Component
export class Template extends Vue {
    get Bobbee() {
        return BobbeeLogoImport;
    }
}

export default toNative(Template);
</script>
